module.exports = __webpack_public_path__ + "assets/banner.84efe94a0948078c572ad980f053d4a8.svg";